import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
const stats = [{
  value: 25,
  suffix: '+',
  label: 'Years of Excellence'
}, {
  value: 160,
  suffix: '+',
  label: 'Projects Completed'
}, {
  value: 20,
  suffix: '+',
  label: 'Team Members'
}];
export function StatsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-20 bg-bg-light relative overflow-hidden" data-id="element-210">
      <div className="max-w-7xl mx-auto px-4 md:px-6" data-id="element-211">
        <div className="bg-white/60 backdrop-blur-sm border border-neutral-200/60 rounded-sm p-12 md:p-16" data-id="element-212">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 text-center" data-id="element-213">
            {stats.map((stat, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            duration: 0.8,
            delay: index * 0.15
          }} className="flex flex-col items-center justify-center" data-id="element-214">
                <div className="flex items-baseline mb-2" data-id="element-215">
                  <Counter value={stat.value} isInView={isInView} data-id="element-216" />
                  <span className="text-3xl md:text-4xl lg:text-5xl font-light text-accent ml-1" data-id="element-217">
                    {stat.suffix}
                  </span>
                </div>
                <span className="text-sm uppercase tracking-widest text-text-muted font-light mt-2" data-id="element-218">
                  {stat.label}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}
function Counter({
  value,
  isInView
}: {
  value: number;
  isInView: boolean;
}) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (isInView) {
      let start = 0;
      const duration = 2000;
      const increment = value / (duration / 16);
      const timer = setInterval(() => {
        start += increment;
        if (start >= value) {
          setCount(value);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, 16);
      return () => clearInterval(timer);
    }
  }, [value, isInView]);
  return <span className="text-4xl md:text-5xl lg:text-6xl font-light text-primary" data-id="element-219">
      {count}
    </span>;
}